"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var ReactDom = __importStar(require("react-dom"));
var SingletonComponentWrapper_1 = require("../Components/SingletonComponentWrapper");
var Singleton = /** @class */ (function () {
    function Singleton(component) {
        var _this = this;
        this.component = component;
        this.unmountDelayHandle = -1;
        this.updateDelayHandle = -1;
        this.eventListeners = [];
        ReactDom.render(React.createElement(SingletonComponentWrapper_1.SingletonComponentWrapper, { referenceCallback: function (_instance) { return (_this.scwInstance = _instance); }, wrappedComponent: this.component }), document.body.appendChild(document.createElement("div")));
    }
    Singleton.prototype.mount = function (props) {
        if (typeof this.scwInstance !== "undefined")
            this.scwInstance.setState({
                wrappedProps: props,
                shouldBeMounted: true
            });
        return this;
    };
    Singleton.prototype.update = function (props, delayMs) {
        var _this = this;
        window.clearTimeout(this.updateDelayHandle);
        if (typeof delayMs !== "undefined")
            this.updateDelayHandle = window.setTimeout(function () { return _this.update(props); }, delayMs);
        else if (typeof this.scwInstance !== "undefined")
            this.scwInstance.setState({
                wrappedProps: props
            });
        return this;
    };
    Singleton.prototype.unmount = function (delayMs) {
        var _this = this;
        window.clearTimeout(this.unmountDelayHandle);
        if (typeof delayMs !== "undefined")
            this.unmountDelayHandle = window.setTimeout(function () { return _this.unmount(); }, delayMs);
        else if (typeof this.scwInstance !== "undefined")
            this.scwInstance.setState({
                shouldBeMounted: false
            });
        return this;
    };
    Singleton.prototype.clearListeners = function () {
        this.eventListeners = [];
        return this;
    };
    Singleton.prototype.on = function (eventName, callback) {
        this.eventListeners.push({ eventName: eventName, callback: callback });
        return this;
    };
    Singleton.prototype.emit = function (eventName, eventData) {
        for (var _i = 0, _a = this.eventListeners; _i < _a.length; _i++) {
            var _eventListener = _a[_i];
            if (_eventListener.eventName === eventName)
                _eventListener.callback(eventData);
        }
        return this;
    };
    Singleton.prototype.toVoid = function () { };
    return Singleton;
}());
exports.Singleton = Singleton;
//# sourceMappingURL=Singleton.js.map